import {ENDPOINTS} from "../common/endpoints";
import {PackageCreateRequest, PackageGuidDto, PackageStockGuidDto, PackageUpdateRequest} from "../models/Packages/IPackage";
import {baseAPI} from "./BaseAPI";
import {TAGS} from "./TagTypes";

type SearchPropsType = {
    page: number;
    pageSize: number;
    searchPhrase: string;
    descending: boolean;
    orderByName: boolean;
};

type SearchResponseType = {
    data: PackageGuidDto[];
    page: number;
    pageCount: number;
    pageSize: number;
    totalCount: number;
};

export const packageAPI = baseAPI.injectEndpoints({
    endpoints: (build) => ({
        getAvailablePackageNames: build.query<string[], void>({
            query: () => ({url: ENDPOINTS.PACKAGES.AVAILABLE_NAMES, method: 'GET'}),
            providesTags: [TAGS.AVAILABLE_PACKAGE_NAMES],
        }),
        getPackagesForOrderV2: build.query<PackageGuidDto[], void>({
            query: () => ({url: ENDPOINTS.PACKAGES.V2_FOR_ORDER, method: 'GET'}),
            providesTags: [TAGS.PACKAGES_FOR_ORDERS],
        }),

        getPackagesByPages: build.query<SearchResponseType, SearchPropsType>({
            query: ({
                        page,
                        pageSize,
                        searchPhrase,
                        descending,
                        orderByName
                    }: SearchPropsType) => ({
                url: ENDPOINTS.PACKAGES.V2,
                method: 'GET',
                params: {page, pageSize, searchPhrase, orderByName, descending},
            }),
            providesTags: (result) => [TAGS.PACKAGES],
        }),

        getPackageById: build.query<PackageGuidDto, string>({
            query: (id) => ({url: `${ENDPOINTS.PACKAGES.V2}/${id}`, method: 'GET'}),
            providesTags: (_result, _error, id) => [{type: TAGS.PACKAGES, id}],
        }),

        getStocksByPackageId: build.query<PackageStockGuidDto[], string>({
            query: (id) => ({
                url: `${ENDPOINTS.PACKAGES.V2}/${id}/stocks`,
                method: 'GET',
            }),
            providesTags: (_result, _error, id) => [{type: TAGS.PACKAGES, id: `stocks-${id}`}],
        }),

        createPackage: build.mutation<PackageGuidDto, PackageCreateRequest>({
            query: (body) => ({
                url: ENDPOINTS.PACKAGES.V2,
                method: 'POST',
                body,
            }),

            invalidatesTags: [TAGS.PACKAGES, TAGS.AVAILABLE_PACKAGE_NAMES, TAGS.PACKAGES_LIGHT, TAGS.PACKAGES_FOR_ORDERS, TAGS.PRODUCT_TYPE],
        }),

        updatePackage: build.mutation<PackageGuidDto, {id: string; body: PackageUpdateRequest}>({
            query: ({id, body}) => ({url: `${ENDPOINTS.PACKAGES.V2}/${id}`, method: 'PUT', body}),

            invalidatesTags: (_result, _error, {id}) => [
                TAGS.PACKAGES,
                {type: TAGS.PACKAGES, id},
                {type: TAGS.PACKAGES, id: `stocks-${id}`},
                TAGS.AVAILABLE_PACKAGE_NAMES,
                TAGS.PACKAGES_LIGHT,
                TAGS.PACKAGES_FOR_ORDERS,
                TAGS.PRODUCT_TYPE,
            ]
        }),

        deletePackage: build.mutation<void, string>({
            query: (id) => ({url: `${ENDPOINTS.PACKAGES.V2}/${id}`, method: 'DELETE'}),
            invalidatesTags: [TAGS.PACKAGES, TAGS.AVAILABLE_PACKAGE_NAMES, TAGS.PACKAGES_LIGHT, TAGS.PACKAGES_FOR_ORDERS, TAGS.PRODUCT_TYPE],
        }),
    }),
});
